module.exports = __webpack_public_path__ + "img/google-profile.66b79b6a.jpg";